import { toSnakeCase } from 'remeda'

/**
 * Generates a squared banner image file name based on the given collection handle.
 * The file name is constructed by prefixing 'squared_banner_', applying snake case to the collection handle,
 * and conditionally appending '_img' if the collection handle is 'icon' because `_icon` is a reserved word
 * in Shopify CDN filenames. The file extension '.jpg' is always appended.
 *
 * @param collectionHandle - The handle of the collection used to generate the file name.
 * @returns The generated squared banner image file name.
 * @example
 * // returns 'squared_banner_my_collection.jpg'
 * getSquaredBannerImageFileName('myCollection');
 * @example
 * // returns 'squared_banner_icon_img.jpg'
 * getSquaredBannerImageFileName('icon');
 */
export const getSquaredBannerImageFileName = (
  collectionHandle: string,
): string => {
  return `squared_banner_${toSnakeCase(collectionHandle)}${
    collectionHandle === 'icon' ? '_img' : ''
  }.jpg`
}
